/* eslint-disable */
// import * as lottie from '../components/bodymovin.js';

let prestations = [];
let $window = $(window);
let $links = $('.block-link .link');
let nav = $('.nav__prestation');

function populatePrestations(){
  let windowHeight = $window.height();
  let threshold = 0.40;

  $('.block-prestation article').each(function (k, v) {
    let name = $(v).attr('id');
    let $prestation = $('#' + name);
    let prestation = {
      name: name,
      element: $prestation,
      link: $('.nav__prestation .link[href="#' + name + '"]'),
      top: $prestation.offset().top - (windowHeight*threshold),
      bottom: $prestation.offset().top + $prestation.height() - (windowHeight*threshold)
    };
    prestations.push(prestation);
  });
}

function scrollFixed() {
  let logo = $('.logo-text.wexperience.item');
  let scrollTop = $window.scrollTop();

  // let navTop = nav.offset().top;
  let navTop = nav.offset().top - logo.height() - 20;

  nav.toggleClass('fixed', scrollTop > navTop && scrollTop < (prestations[prestations.length - 1].bottom));

  $window.scroll(function () {
    scrollTop = $window.scrollTop();

    nav.toggleClass('fixed', scrollTop > navTop && scrollTop < (prestations[prestations.length - 1].bottom));
  });
}

function scrollActive() {
  let index = -1;
  let last = false;
  let scrollTop = $window.scrollTop();

  $window.scroll(function () {
    let direction = $window.scrollTop() > scrollTop ? 'down' : 'up';
    scrollTop = $window.scrollTop();

    // Add class active on scroll down
    if(direction === 'down'){
      if (prestations[index + 1] && scrollTop > prestations[index + 1].top) {
        index++;
        $links.removeClass('active');
        prestations[index].link.addClass('active');
      }
    }
    else{
      if (prestations[index - 1] && scrollTop < prestations[index - 1].bottom) {
        index--;
        $links.removeClass('active');
        prestations[index].link.addClass('active');
      }
    }

  });
}

function clickActive() {
  $('.nav__prestation .link').click(function (e) {
    setTimeout(() => {
      $('.block-link .link').removeClass('active');
      $(this).addClass('active');
    }, 530);
  });
}

function lastArticle()  {
  $window.scroll(function () {
    if ($window.scrollTop() > prestations[prestations.length - 1].bottom) {
      if (!nav.hasClass('fixed')) {
        nav.css({
          "position": "absolute",
          "top": prestations[prestations.length - 1].bottom - nav.height() + 40
        });
      }
    } else {
      if (nav.hasClass('fixed')) {
        nav.attr('style', '');
      }
    }
  });
}

export default {
  init() {
    if (window.matchMedia("(min-width: 960px)").matches) {
      populatePrestations();
      scrollFixed();
      scrollActive();
      clickActive();
      lastArticle();
    }

    // $.each($('.anim--startAndLoop'), function (k, v) {
    //   let name = $(v).attr('id');
    //   let duration = $(v).data('duration');
    //   listAnimation[k] = {"name" : name, "duration" : duration}
    // });
    // for (const i in listAnimation) {
    //   lottie.start(listAnimation[i].name, listAnimation[i].duration);
    // }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/prestation.js